import React from 'react';

import { GENDER, SALARY_AMT_TYPE } from '../../../../Const';
import { Dropdown, CreatableDropdown } from '../../../../components';
import GoBackButton from '../../../../components/GoBackButton';

function PreCompanypostjobs({
    input,
    handleInput,
    handleSubmit,
    simpleValidator,
    show,
    id
}) {

    return (
        <div className="job-bx submit-resume">
            <div className="job-bx-title clearfix">
                <h5 className="font-weight-700 pull-left text-uppercase">Post A Job</h5>
                <GoBackButton />
            </div>
            {
                show?.approve_status === 'p' ?
                    <span className="text-danger font-weight-bold">
                        Please Wait untill your profile approved by admin.
                    </span>
                    : show?.approve_status === 'd' ?
                        <span className="text-danger font-weight-bold">
                            Job Office Coordinator has denied your profile. Please contact Job Office Coordinator.
                        </span>
                        :
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-lg-6 col-md-6">
                                    <div className="form-group">
                                        <label>Job Title <span className="text-danger font-weight-bold">*</span></label>
                                        <CreatableDropdown
                                            url={`job-titles/`}
                                            name="title"
                                            className="form-control"
                                            value={input?.title}
                                            onChange={handleInput}
                                            required={true}
                                        />
                                        <span className="text-danger">
                                            {simpleValidator.current.message("title", input.title, "required")}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    <div className="form-group">
                                        <label>No. of Vacancies <span className="text-danger font-weight-bold">*</span></label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            placeholder="eg. 5"
                                            onChange={handleInput}
                                            value={input?.vacancies}
                                            name='vacancies'
                                            onKeyPress={e => e.target.value.length >= 5 && e.preventDefault()}
                                        />
                                        <span className="text-danger">
                                            {simpleValidator.current.message("vacancies", input.vacancies, "required")}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-12">
                                    <div className="form-group">
                                        <label>Description <span className="text-danger font-weight-bold">*</span></label>
                                        <textarea
                                            className="form-control"
                                            placeholder="Description"
                                            onChange={handleInput}
                                            value={input?.description}
                                            name='description'
                                        />
                                        <span className="text-danger">
                                            {simpleValidator.current.message("description", input.description, "required")}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    <div className="form-group">
                                        <label>Job Type <span className="text-danger font-weight-bold">*</span></label>
                                        <CreatableDropdown
                                            type='multi'
                                            url={`job-types/`}
                                            name="type"
                                            className="form-control"
                                            value={input?.type}
                                            onChange={handleInput}
                                        />
                                        <span className="text-danger">
                                            {simpleValidator.current.message("type", input.type, "required")}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    <div className="form-group">
                                        <label>Job Category <span className="text-danger font-weight-bold">*</span></label>
                                        <CreatableDropdown
                                            type='multi'
                                            url={`job-categories/`}
                                            name="category"
                                            className="form-control"
                                            value={input?.category}
                                            onChange={handleInput}
                                        />
                                        <span className="text-danger">
                                            {simpleValidator.current.message("category", input.category, "required")}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    <div className="form-group">
                                        <label>Minimum Experience (Yrs) <span className="text-danger font-weight-bold">*</span></label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            placeholder="eg. 2"
                                            onChange={handleInput}
                                            value={input?.min_experience}
                                            name='min_experience'
                                            onKeyPress={e => e.target.value.length >= 2 && e.preventDefault()}
                                        />
                                        <span className="text-danger">
                                            {simpleValidator.current.message("min_experience", input.min_experience, "required")}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    <div className="form-group">
                                        <label>Maximum Experience (Yrs) <span className="text-danger font-weight-bold">*</span></label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            placeholder="eg. 4"
                                            onChange={handleInput}
                                            value={input?.max_experience}
                                            name='max_experience'
                                            onKeyPress={e => e.target.value.length >= 2 && e.preventDefault()}
                                        />
                                        <span className="text-danger">
                                            {simpleValidator.current.message("max_experience", input.max_experience, `required|gt:${input.min_experience}`)}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    <div className="form-group">
                                        <label>Minimum Salary <span className="text-danger font-weight-bold">*</span></label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            placeholder="eg. 10000"
                                            onChange={handleInput}
                                            value={input?.min_salary}
                                            name='min_salary'
                                            onKeyPress={e => e.target.value.length >= 8 && e.preventDefault()}
                                        />
                                        <span className="text-danger">
                                            {simpleValidator.current.message("min_salary", input.min_salary, "required|max:15")}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    <div className="form-group">
                                        <label>Maximum Salary <span className="text-danger font-weight-bold">*</span></label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            placeholder="eg. 20000"
                                            onChange={handleInput}
                                            value={input?.max_salary}
                                            name='max_salary'
                                            onKeyPress={e => e.target.value.length >= 8 && e.preventDefault()}
                                        />
                                        <span className="text-danger">
                                            {simpleValidator.current.message("max_salary", input.max_salary, `required|max:15|gt:${input.min_salary}`)}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    <div className="form-group">
                                        <label>Salary Per <span className="text-danger font-weight-bold">*</span></label>
                                        <Dropdown
                                            name="salary_per"
                                            options={SALARY_AMT_TYPE}
                                            value={input?.salary_per}
                                            onChange={handleInput}
                                        />
                                        <span className="text-danger">
                                            {simpleValidator.current.message("salary_per", input?.salary_per, "required")}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    <div className="form-group">
                                        <label>Required Skills <span className="text-danger font-weight-bold">*</span></label>
                                        <CreatableDropdown
                                            url="skills/"
                                            type="multiselect"
                                            name="skills"
                                            value={input?.skills}
                                            onChange={handleInput}
                                            required={true}
                                        />
                                        <span className="text-danger">
                                            {simpleValidator.current.message("required skills", input.skills, "required")}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    <div className="form-group">
                                        <label>Preferred Gender <span className="text-danger font-weight-bold">*</span></label>
                                        <Dropdown
                                            name="preferred_gender"
                                            options={GENDER}
                                            value={input?.preferred_gender}
                                            gender={true}
                                            onChange={handleInput}
                                        />
                                        <span className="text-danger">
                                            {simpleValidator.current.message("preferred_gender", input.preferred_gender, "required")}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    <div className="form-group">
                                        <label>Preferred Qualification <span className="text-danger font-weight-bold">*</span></label>
                                        <Dropdown
                                            url={`qualification/`}
                                            type="multiselect"
                                            name="preferred_qualification"
                                            value={input?.preferred_qualification}
                                            gender={true}
                                            onChange={handleInput}
                                        />
                                        <span className="text-danger">
                                            {simpleValidator.current.message("preferred_qualification", input.preferred_qualification, "required")}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    <div className="form-group">
                                        <label>Career level <span className="text-danger font-weight-bold">*</span></label>
                                        <Dropdown
                                            url={`career-level/`}
                                            name="career_level"
                                            className="form-control"
                                            value={input?.career_level}
                                            onChange={handleInput}
                                        />
                                        <span className="text-danger">
                                            {simpleValidator.current.message("career_level", input.career_level, "required")}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    <div className="form-group">
                                        <label>Country <span className="text-danger font-weight-bold">*</span></label>
                                        <Dropdown
                                            name="country"
                                            type="multiselect"
                                            url={`country/`}
                                            value={input?.country}
                                            gender={true}
                                            onChange={handleInput}
                                        />
                                        <span className="text-danger">
                                            {simpleValidator.current.message("country", input.country, "required")}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    <div className="form-group">
                                        <label>Region <span className="text-danger font-weight-bold">*</span></label>
                                        <Dropdown
                                            url={`state/`}
                                            type="multiselect"
                                            filters={input?.country?.map(item => item.id)?.length > 0 && `country__in=${input?.country?.map(item => item.id)}`}
                                            name="state"
                                            className="form-control"
                                            value={input?.state}
                                            onChange={handleInput}
                                        />
                                        <span className="text-danger">
                                            {simpleValidator.current.message("state", input.state, "required")}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    <div className="form-group">
                                        <label>Location <span className="text-danger font-weight-bold">*</span></label>
                                        <Dropdown
                                            url={`city/`}
                                            type="multiselect"
                                            filters={input?.state?.map(item => item.id)?.length > 0 && `state__in=${input?.state?.map(item => item.id)}`}
                                            name="city"
                                            className="form-control"
                                            value={input?.city}
                                            onChange={handleInput}
                                        />
                                        <span className="text-danger">
                                            {simpleValidator.current.message("city", input.city, "required")}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    <div className="form-group">
                                        <label>Start Time  <span className="text-danger font-weight-bold">*</span></label>
                                        <input
                                            name="start_time"
                                            value={input.start_time}
                                            onChange={handleInput}
                                            className="form-control"
                                            type="datetime-local"
                                            onKeyPress={(e) => e.preventDefault()}
                                            min={`${new Date().toISOString().split("T")[0]}T00:00`}
                                        />
                                        <span className="text-danger">
                                            {simpleValidator.current.message("start_time", input.start_time, "required")}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    <div className="form-group">
                                        <label>End Time  <span className="text-danger font-weight-bold">*</span></label>
                                        <input
                                            name="end_time"
                                            value={input.end_time || ""}
                                            onChange={handleInput}
                                            className="form-control"
                                            onKeyPress={(e) => e.preventDefault()}
                                            type="datetime-local"
                                            min={`${new Date().toISOString().split("T")[0]}T00:00`}
                                        />
                                        <span className="text-danger">
                                            {simpleValidator.current.message("end_time", input.end_time, `required`)}
                                        </span>
                                    </div>
                                </div>

                                {/* <div className="col-lg-12 col-md-12">
													<div className="form-group">
														<label>Upload File</label>
														<div className="custom-file">
															<p className="m-a0">
																<i className="fa fa-upload"></i>
																Upload File
															</p>
															<input type="file" className="site-button form-control" id="customFile" />
														</div>
													</div>
												</div> */}
                            </div>
                            <button type="button" className="site-button m-b30" style={{ zIndex: 0 }} onClick={handleSubmit}> {id ? "Update" : "Post"} </button>
                        </form>
            }
        </div>
    )
}
export default PreCompanypostjobs;